module.exports = __webpack_public_path__ + "static/media/zeya_folding_arm01.a82fe27c.png";